import Backbone from 'backbone';
import PopupView from "./popup";

export default class NewsletterSubView extends Backbone.View {

    events() {
        return {
            "submit": "submit",
        }
    }

    initialize(options) {
    }

    submit(event) {
        event.preventDefault();

        var email = this.$el.find('input[type=email]').val();

        $.ajax({
            url: "/public-rest/newsletter/subscribe/",
            method: "POST",
            dataType: "json",
            data: {
                email: email
            },
            success: function (data) {
                 new PopupView({
                    data: {'email': email},
                    template: require('ejs!../templates/newsletter-popup.ejs')
                });
            }
        });


    }

}



// WEBPACK FOOTER //
// ./frontend/js/views/newsletter-sub.js